import React from 'react';
import { observer, inject } from 'mobx-react';
import CollectionManager from '../common/CollectionManager';
import Form from './CustomerForm';
import Model from '../../models/Customer';

export default inject('store')(observer(props => {
  return <CollectionManager
    collectionName='customers'
    ListComponent={props.ListComponent}
    FormComponent={Form}
    getItems={props.store.getCustomers}
    getNewItem={() => Model.create()}
    searchPlaceholder='Search customers...'
    addButtonText='Add Customer'
    {...props}
  />
}))


// WEBPACK FOOTER //
// ./src/components/customers/Customers.js